module.exports = __webpack_public_path__ + "img/slide_ren.01cc6d1c.svg";